import React from "react";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./registrationForm.css";
import SglActions from "../common/SglActions";
import SglContext from "../SglContext";


export default function RegistrationConfirmation() {
  const [loading, setLoading] = useState(true);
  const [registration_confirmed, set_registration_confirmed] = useState(false);
  const [company_name, setCompanyName] = useState("");
  const Sgl = useContext(SglContext)

  //API END POINTS
  const sgl_webservice_registration_confirmation =
  Sgl.sglApiUrl + "/iphone.php/webservice/RegConfirmation";

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  }
  useEffect(() => {
    axios
      .all([
        axios.get(sgl_webservice_registration_confirmation, {
          params: {
            customer_id: Sgl.company_id,
            key: getQueryVariable("key"),
          },
        }),
      ])
      .then(
        axios.spread((response) => {
          setLoading(false);
          setCompanyName(response.data.company_name);
          set_registration_confirmed(response.data.registration_confirmed);
        })
      );
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div className='sgl-content-wrapper registrationformcss'>
      <div className='sgl-plugin'>
        <div id='sgl-plugin-registration-success-message'>
          {(() => {
            if (registration_confirmed) {
              return (
                <div>
                  <h1>Thank You</h1>
                  <p>
                    Your registration has been confirmed for {company_name}!
                    <br />
                    <br />
                    Now that you've registered you may begin using{" "}
                    {company_name} right away. <br />
                    <br />
                    You can now:
                    <br />
                  </p>
                  <ul>
                    <li>View your personal up-to-the-minute schedule</li>
                    <li>Get the Order-of-Go</li>
                    <li>View live ring status</li>
                    <li>Add and drop classes</li>
                    <li>See results and division totals</li>
                    <li>Order supplies</li>
                    <li>Checkout and pay your bill</li>
                  </ul>
                </div>
              );
            } else {
              return (
                <div>
                  <h1>Error</h1>
                  <p>Registration not found</p>
                </div>
              );
            }
          })()}
        </div>
      </div>
    </div>
  );
}
